import Image1 from "../../assets/publication/data in breaf.jpg";
import Image2 from "../../assets/publication/BIM.jpg";
import Image3 from "../../assets/publication/ijrasat.jpg";
import Image4 from "../../assets/publication/X22150161.jpg";
export const Data= [
    {
        id: 1,
        image: Image4,
        title: "XSE-TomatoNet: An explainable AI based tomato leaf disease classification method using EfficientNetB0 with squeeze-and-excitation blocks and multi-scale feature fusion",
        description:
        "M. Assaduzzaman, P. Bishshash, Md. A. S. Nirob, A. A. Marouf, J. G. Rokne, and R. Alhajj, “XSE-TomatoNet: An Explainable AI based Tomato Leaf Disease Classification Method Using EfficientNetB0 with Squeeze-and-Excitation Blocks and Multi-Scale Feature Fusion,” MethodsX, p. 103159, Jan. 2025, doi: https://doi.org/10.1016/j.mex.2025.103159.‌",
        link:"https://www.sciencedirect.com/science/article/pii/S221501612500007X"
    },
    {
        id: 2,
        image: Image1,
        title: "A comprehensive dragon fruit image dataset for detecting the maturity and quality grading of dragon fruit",
        description:
        "T. Khatun, Md. A. S. Nirob, P. Bishshash, M. Akter, and M. S. Uddin, “A Comprehensive Dragon Fruit Image Dataset for Detecting the Maturity and Quality Grading of Dragon Fruit,” Data in Brief, p. 109936, Dec. 2023, doi: https://doi.org/10.1016/j.dib.2023.109936.",
        link:"https://www.sciencedirect.com/science/article/pii/S235234092300968X"
    },

    {
        id: 3,
        image: Image3,
        title: "Enhancing Credit Card Fraud Detection: A Novel Approach with Random Forest and Behavioral Biometrics ......... ........ .........",
        description:
        "Srinivasa Rao Adapa, and Md. Asraful Sharker Nirob. “Enhancing Credit Card Fraud Detection: A Novel Approach with Random Forest and Behavioral Biometrics.” International Journal for Research in Applied Science and Engineering Technology, vol. 12, no. 3, 31 Mar. 2024, pp. 2858–2866, https://doi.org/10.22214/ijraset.2024.59510. Accessed 16 May 2024.",
        link:"https://doi.org/10.22214/ijraset.2024.59510"
    },

    {
        id: 4,
        image: Image1,
        title: "A comprehensive cotton leaf disease dataset for enhanced detection and classification ......... ........ .........",
        description:
        "Prayma Bishshash, Md. Asraful Sharker Nirob, Md. Habibur Shikder, Mr. Afjal Hossan Sarower, Dr. Touhid Bhuiyan, and Sheak, “A Comprehensive Cotton Leaf Disease Dataset for Enhanced Detection and Classification,” Data in Brief, pp. 110913–110913, Sep. 2024, doi: https://doi.org/10.1016/j.dib.2024.110913.",
        link:"https://www.sciencedirect.com/science/article/pii/S235234092400876X"
    },
    {
        id: 5,
        image: Image1,
        title: "A benchmark dataset for analyzing hematological responses to dengue fever in Bangladesh ......... ........ .........",
        description:
        "M. Assaduzzaman, O. Islam, Md. A. S. Nirob, Md. M. H. Mim, and A. Mahmud, “A Benchmark Dataset for Analyzing Hematological Responses to Dengue Fever in Bangladesh,” Data in Brief, p. 111030, Oct. 2024, doi: https://doi.org/10.1016/j.dib.2024.111030.",
        link:"https://www.sciencedirect.com/science/article/pii/S2352340924009922"
    },
    {
        id: 6,
        image: Image2,
        title: "Malnutrition prediction among under-five children using Machine learning techniques  ......... ........ .........",
        description:
        " Md. A. S. Nirob, Md. P. Bishshash, and M. Assaduzzaman “A Benchmark Dataset for Analyzing Hematological Responses to Dengue Fever in Bangladesh,” Data in Brief, p. 111030, Oct. 2024, doi:  Md. A. S. Nirob, Md. P. Bishshash, and M. Assaduzzaman “A Benchmark Dataset for Analyzing Hematological Responses to Dengue Fever in Bangladesh,” Data in Brief, p. 111030, Oct. 2024, doi:...... .............. ........    ........ ...... ........                                        ....    ....    ....    .....       .....       ",
        link:"https://scholar.google.com/citations?view_op=view_citation&hl=en&user=ul2pGgMAAAAJ&citation_for_view=ul2pGgMAAAAJ:u-x6o8ySG0sC"
    },
    {
        id: 7,
        image: Image1,
        title: "A comprehensive image dataset for the identification of lemon leaf diseases and computer vision applications",
        description:
        "K. Siam, Prayma Bishshash, Md. Asraful Sharker Nirob, S. B. Mamun, Md Assaduzzaman, and Sheak, “A Comprehensive Image Dataset for the Identification of Lemon Leaf Diseases and Computer Vision Applications,” Data in Brief, pp. 111244–111244, Dec. 2024, doi: https://doi.org/10.1016/j.dib.2024.111244.",
        link:"https://www.sciencedirect.com/science/article/pii/S235234092401206X"
    },

];